<!-- Main Layout -->
<nz-layout
  class="smooth-main"
  [style.marginLeft.px]="isCollapsed ? sidebarWidth : 0"
  style="min-height: 100vh; transition: all 0.3s ease-in"
>
  <!-- Header -->
  <nz-header
    class="smooth-header"
    [style.left.px]="isCollapsed ? sidebarWidth : 0"
    style="
      transition: all 0.3s ease-in;
      position: fixed;
      top: 0;
      right: 0;
      height: 64px;
      z-index: 1001;
      background: #fff;
      padding: 0;
    "
  >
    <app-header
      [isHomeHeader]="true"
      class="header-content"
      [isCollapsed]="isCollapsed"
      (toggle)="toggleSidebar()"
    ></app-header>
  </nz-header>
  <router-outlet> </router-outlet>
  <nz-footer style="width: 100%; padding: 0">
    <app-footer></app-footer>
  </nz-footer>
</nz-layout>
